import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DynamicComponentComponent } from 'app/modules/admin/dynamic-component/dynamic-component.component';
import { MatIconModule } from '@angular/material/icon';
import { ChartsModule } from "@progress/kendo-angular-charts";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SharedService } from 'app/services/shared.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageService } from 'app/services/page.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { DrakeQuickeditComponent } from '../drake-quickedit/drake-quickedit.component';
import { ContextMenuEvent } from '@progress/kendo-angular-menu';

@Component({
    selector: 'd',
    standalone: true,
    templateUrl: './drake-scope-quickedit.component.html',
    styleUrls: ['./drake-scope-quickedit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        DynamicComponentComponent,
        DrakeQuickeditComponent,
        CommonModule,
        HttpClientModule,
        ChartsModule,
        MatIconModule,
        InputsModule,
    ]
})
export class DrakeScopeQuickeditComponent implements OnInit {
    public pageData: any;
    public baseData: any = {};
    public viewCode: string = '';
    public filter: string = '{}';
    public sort: string = '{}';
    public commandName: string = 'READ';
    public scope: string = '';
    public toolbar = {
        home: {
            newSheet: false,
        }
    };

    constructor(
        private sharedService: SharedService,
        private router: Router,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private pageService: PageService, private drakeShared: DrakeSharedService) {
    }

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        //this.observeContextMenu();
        this.setGridConfig();

    }

    setGridConfig() {
        this.drakeShared.currentBaseData = this.baseData;
        this.route.params.subscribe(params => {
            this.pageService.getPageByUrl(`d/${params?.['scope']}/q`).subscribe((result: any) => {
                this.pageData = result;
                this.drakeShared.currentPageData = result;
                const urlParams = new URLSearchParams(window.location.search);
                const filter = urlParams.get('filter') || '{}';
                this.filter = this.decodeJSONString(filter);
                const sort = urlParams.get('sort') || '{}';
                this.sort = this.decodeJSONString(sort);
                this.commandName = 'READ';
                this.scope = params['scope'].toUpperCase();
                this.viewCode = params['viewCode'] ? params['viewCode'].toUpperCase() : this.scope + '.DEFAULT';
            });
        });
    }

    decodeJSONString(str: string): string {
        try {
            const decodedStr = str.replace(/\\\"/g, '"');
            const parsedJSON = JSON.parse(decodedStr);
            return JSON.stringify(parsedJSON);
        } catch (e) {
            console.error('Invalid JSON string:', str);
            return '{}'; // Fallback to an empty object if parsing fails
        }
    }

    observeContextMenu(): void {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    this.removeMergeMenuItems();
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    removeMergeMenuItems(): void {
        const contextMenu = document.querySelector('.k-context-menu');
        if (contextMenu) {
            const menuItems = contextMenu.querySelectorAll('.k-item');
            menuItems.forEach(item => {
                if (item.textContent && (item.textContent.toLowerCase().includes('merge') || item.textContent.toLowerCase().includes('unmerge'))) {
                    item.parentElement?.removeChild(item);
                }
            });
        }
    }
}
